import {Component, Inject, PLATFORM_ID} from '@angular/core';
import {isPlatformBrowser, NgForOf} from '@angular/common';
import {NavigationEnd, Router, RouterLink} from '@angular/router';
import {Meta, Title} from '@angular/platform-browser';
import {filter} from 'rxjs';
import {PddService} from '../../services/pdd.service';
@Component({
    selector: 'pdd-home-page',
    templateUrl: './pddhome.component.html',
  imports: [
    NgForOf,
    RouterLink
  ],
    styleUrl: './pddhome.component.less'
})
export class  PDDHomePageComponent  {
  constructor(@Inject(PLATFORM_ID) private platformId: Object, private router: Router, public PddService: PddService,   private title: Title, private meta: Meta) {
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        if (isPlatformBrowser(this.platformId)) {
          window.scrollTo({
            top: 0,
            behavior: 'smooth' // или убери behavior для мгновенного скролла
          });
        }
      });
  }

  ngOnInit(): void {
    this.title.setTitle('Правила дорожного движения статьи (ПДД) 2026 — все пункты с последними изменениями  | ПДД');

    this.meta.updateTag({
      name: 'description',
      content: 'Полный текст Правил дорожного движения статьи (ПДД) 2026. Все пункты ПДД в актуальной редакции с последними изменениями, удобной навигацией по разделам, дорожными знаками, разметкой и пояснениями.'
    });

    this.meta.updateTag({
      name: 'keywords',
      content: 'ПДД 2026, правила дорожного движения, правила дорожного движения 2026, ПДД РФ, полный текст ПДД, все пункты ПДД, актуальная редакция ПДД, изменения ПДД 2026, ПДД онлайн, дорожные знаки, дорожная разметка, сигналы светофора, подготовка к экзамену ПДД'
    });
  }
}
